/**
 * Audit events API.
 */

import apiClient from './client';
import type { AuditListResponse } from './types';

export async function getAuditEvents(tenantId: string): Promise<AuditListResponse> {
  const response = await apiClient.get('/audit', {
    params: { tenant_id: tenantId },
  });
  return response.data;
}
